import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface BlogLayoutProps {
  title: string;
  description: string;
  tag: string;
  date: string;
  readTime: string;
  image: string;
  imageAlt: string;
  breadcrumbLabel: string;
  children: React.ReactNode;
}

export default function BlogLayout({
  title,
  description,
  tag,
  date,
  readTime,
  image,
  imageAlt,
  breadcrumbLabel,
  children,
}: BlogLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <article className="pt-24 pb-16 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors no-underline">Strona główna</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700">{breadcrumbLabel}</span>
            </nav>

            <header className="mb-10">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4">
                {tag}
              </span>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
                {title}
              </h1>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                {description}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500 flex-wrap">
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line"></i>
                  Aktualizacja: {date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  Czas czytania: {readTime}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line"></i>
                  KakobuyPolska
                </span>
              </div>
            </header>

            <div className="relative w-full h-56 md:h-72 rounded-2xl overflow-hidden mb-10">
              <img
                src={image}
                alt={imageAlt}
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>

            {children}

            <nav className="flex flex-wrap items-center gap-3 text-xs text-foreground-500 pt-4 mt-8 border-t border-background-200/70">
              <span>Powiązane:</span>
              <Link to="/" className="text-primary-600 hover:text-primary-700 no-underline">Strona główna KakobuyPolska</Link>
              <a href="/#categories" className="text-foreground-600 hover:text-primary-500 no-underline cursor-pointer">Kategorie produktów</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-600 hover:text-primary-500 no-underline">Kaspreadsheet.com</a>
            </nav>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}